import {Component, OnInit, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation, OnDestroy} from "@angular/core";
import {MainService} from "../Services/service.service";
import {DTOAdvertisement, DTOAdvertisementCategory, SubRegion, DTOSubRegion} from "../api/WickedApiClient";
import {GeolocationService} from "../Services/geolocation.service";
import {Subject, Subscription, Observable} from "rxjs";
import {CookieService} from "ngx-cookie-service";
import {Router, ActivatedRoute} from "@angular/router";
import Player from "@vimeo/player";
import {SearchRouteService} from "../Services/searchroute.service";
import {flatMap, tap, merge, mergeMapTo} from "rxjs/operators";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

  categories: DTOAdvertisementCategory[];
  mostPopularCities: Observable<SubRegion[]>;

  category: string = "women-seeking-men";
  type: string = "long-term";
  withPicture: string = "";
  city: string = "il-chicago";


  public isPremium: boolean = false;
  currentSearchRuleChangedSubsctiption: Subscription;

  get showWickedVideo(): boolean {
    return this.service.showStartVideo;
  }
  set showWickedVideo(val: boolean) {
    this.service.showStartVideo = val;
  }

  @ViewChild("wickedvideo", {static: false}) wickedVideo: ElementRef;

  constructor(public service: MainService, public geolocationService: GeolocationService, public cookieService: CookieService, public route: Router, private activeRoute: ActivatedRoute, private searchRouteService: SearchRouteService) {
    this.route.events.subscribe(val => {

      console.log(val);

    });
    this.isPremium = this.service.userService.isPremium();
    if(this.constructor != HomeComponent)
      this.mostPopularCities = this.geolocationService.CitiesByPopulation(60, true);
    else this.mostPopularCities = this.geolocationService.CitiesByPopulation(60);

    this.service.advService.getCategories(false).then(categories => {
      this.categories = categories;
    });

    if(this.cookieService.check("hiddenVideo")) {
      this.showWickedVideo = false;
    }

    this.route.onSameUrlNavigation = "ignore";


  }

  private _muteBanner: boolean = true;
  public get muteBanner(): boolean {
    return this._muteBanner;
  }
  public set muteBanner(value: boolean) {
    this._muteBanner = value;
  }

  ngOnDestroy(): void {
    if(this.currentSearchRuleChangedSubsctiption) {
      this.currentSearchRuleChangedSubsctiption.unsubscribe();
    }

  }

  ngAfterViewInit(): void {
    if(this.showWickedVideo) {
      let player = new Player(this.wickedVideo.nativeElement, {id: 373344002, byline: false, portrait: false, title: false, autoplay: true, width: this.wickedVideo.nativeElement.offsetWidth, height: this.wickedVideo.nativeElement.offsetHeight});
      player.ready().catch(e => {
        this.showWickedVideo = false;
      });

      player.on("play", () => {
        this.cookieService.set("hiddenVideo", "true");
      });

      player.on("ended", () => {
        this.showWickedVideo = false;
      });

      player.on("error", () => {
        this.showWickedVideo = false;
      });
    }



    //if (this.activeRoute.snapshot.params && this.activeRoute.snapshot.params.cityId) {
    //  let city = this.mostPopularCities.find(x => x.subRegionId == this.activeRoute.snapshot.params.cityId);
    //  if (city) {
    //    this.changeSubRegion(city);
    //  }
    //}

    this.service.hideLoader();

  }

  ngOnInit(): void {

    this.activeRoute.queryParamMap.subscribe(params => {
      let action = params.get("action");
      let param = params.get("param");
      if(action === "new-password") {
        if(param && param.length > 0) {
          this.route.navigate(["/new-password", param]);
        }
      } else if(action === "validate-email") {
        if(param && param.length > 0) {
          this.route.navigate(["/validate-email", param]);
        }
      }
      //validate-email/d501e597-e1da-4622-a2a2-dda1d089ec79
    });

    this.currentSearchRuleChangedSubsctiption = this.service.advService.searchDataStandard.currentSearchRuleChanged.subscribe(rule => {
      if(rule.advertisementCategoryId) {
        let category = this.categories.find(c => c.advertisementCategoryId == rule.advertisementCategoryId);
        if(category) {
          this.category = category.name;
        }
      }
      if(rule.casualDating) {
        this.type = "casual-dating";
      } else {
        this.type = "long-term";
      }

      if(rule.withPicturesOnly) {
        this.withPicture = "-with-picture";
      }

      if(rule.subRegionId) {
        this.geolocationService.GetSubregion(rule.subRegionId).then((subreg) => {
          if(subreg) {
            this.city = `${subreg.region.shortName}-${subreg.name}`
          }
        });
      }
    });


  }

  skipVideoPlay($event: MouseEvent) {
    this.cookieService.set("hiddenVideo", "true");
    this.showWickedVideo = false;
  }

  toKebabCase(str: string): string {
    return str
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/[\s_]+/g, '-')
      .toLowerCase()
  }

  getCityUrl(city: SubRegion) {
    return this.toKebabCase(`/${city.region.shortName}-${city.name}-${this.type}`)
  }

  goToCategoryUrl(e, category: DTOAdvertisementCategory, casualDating: boolean) {
    e.preventdefault;
    const goToUrl = (locationUrl = "") => {
      let url = "";
      if(casualDating) {
        url = this.toKebabCase(`/${locationUrl}casual-dating-${category.name}`);
      } else {
        url = this.toKebabCase(`/${locationUrl}long-term-${category.name}`);
      }
      this.service.route.navigate([url]);
    }

    let locationUrl = "";
    const selectedRegionId = this.service.selectedSearchParams.region;
    const selectedSubregionId = this.service.selectedSearchParams.subregion;
    if(selectedRegionId && selectedSubregionId) {
      this.service.advService.getRegionsOnlyPromise().then(regions => {
        const selectedRegion = regions.find(r => r.regionId == selectedRegionId);
        locationUrl += selectedRegion.shortName + "-";
        const subregions = this.service.advService.getSubRegionsByRegionId(selectedRegionId);
        const selectedSubregion = subregions.find(r => r.subRegionId == selectedSubregionId);
        locationUrl += selectedSubregion.name + "-";
      }).then(r => {
        goToUrl(locationUrl);
      }).catch(function (error) {
        console.log(error);
      });;
    } else {
      goToUrl();
    }
  }

  getCategoryUrl(category: DTOAdvertisementCategory, casualDating: boolean) {
    if(casualDating) {
      return this.toKebabCase(`/casual-dating-${category.name}`)
    } else {
      return this.toKebabCase(`/long-term-${category.name}`)
    }
  }

}
